import {
  FETCH_CONSULTATIONS,
  CANCEL_CONSULTATION,
  UPDATE_CONSULTATION,
  CREATE_CONSULTATION,
  COMPLETE_CONSULTATION,
} from './consultationsActionsTypes';
import { CONSULTATIONS_STATUSES } from '@/configs';
import { get } from '@/utils/helpers';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  isAuth: false,
};

const consultationsReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_CONSULTATIONS}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_CONSULTATIONS}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_CONSULTATIONS}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case `${UPDATE_CONSULTATION}_FULFILLED`:
      if (!state.isLoaded) return state;
      return {
        ...state,
        data: {
          ...(state?.data || {}),
          results: get(state, ['data', 'results'], []).map((i) => {
            if (Number(i.id) === Number(payload.fromId)) {
              return payload;
            }
            return i;
          }),
        },
      };

    case `${CREATE_CONSULTATION}_FULFILLED`:
      if (!state.isLoaded) return state;
      return {
        ...state,
        data: {
          ...(state?.data || {}),
          results: [payload, ...get(state, ['data', 'results'], [])],
        },
      };

    case `${CANCEL_CONSULTATION}_FULFILLED`:
      if (!state.isLoaded) return state;
      return {
        ...state,
        data: {
          ...(state?.data || {}),
          results: get(state, ['data', 'results'], []).map((i) => {
            if (Number(i.id) === Number(payload.id)) {
              return {
                ...i,
                status: CONSULTATIONS_STATUSES.canceled,
                // schedule: null,
                // psychologist: null,
                meeting: null,
              };
            }
            return i;
          }),
        },
      };

    case `${COMPLETE_CONSULTATION}_FULFILLED`:
      if (!state.isLoaded) return state;
      return {
        ...state,
        data: {
          ...(state?.data || {}),
          results: get(state, ['data', 'results'], []).map((i) => {
            if (Number(i.id) === Number(payload.id)) {
              return {
                ...i,
                status: CONSULTATIONS_STATUSES.provided,
                meeting: null,
              };
            }
            return i;
          }),
        },
      };

    default:
      return state;
  }
};

export default consultationsReducer;
